export default __webpack_public_path__ + "static/media/linkedin-icon.34a91f69.svg";